import axios from 'axios'
import { apiPaths } from 'src/core/urlTree'
import { IResBase } from '../base'
import { ILoginResData } from './interfaces'
import { ILoginParams, IResetPasswordDto } from './interfaces/params'

export const AccountServices = () => {
  const loginRequest = async (params: ILoginParams) => {
    return await axios.post<IResBase<ILoginResData>>(apiPaths.login, params).then(res => res.data)
  }

  const resetPassword = async (params: IResetPasswordDto) => {
    const result = await axios.post<IResBase<ILoginResData>>('Account/ResetPassword', params)
    return result.data
  }

  return { loginRequest, resetPassword }
}
